export default function NoInternet() {
  return (
    <div>
      <svg
        width="597"
        height="398"
        viewBox="0 0 597 398"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8595_1715)">
          <path d="M597 0H0V398H597V0Z" fill="white" />
          <path
            d="M294.066 61.698H200.672C199.26 61.698 198.116 62.842 198.116 64.2531V118.644C198.116 120.055 199.26 121.199 200.672 121.199H294.066C295.477 121.199 296.621 120.055 296.621 118.644V64.2531C296.621 62.842 295.477 61.698 294.066 61.698Z"
            stroke="#C0CCD8"
            stroke-miterlimit="10"
          />
          <path
            d="M198.116 72.4758H296.621"
            stroke="#C0CCD8"
            stroke-miterlimit="10"
          />
          <path
            d="M204.476 68.7187C205.347 68.7187 206.053 68.013 206.053 67.1426C206.053 66.2722 205.347 65.5665 204.476 65.5665C203.606 65.5665 202.9 66.2722 202.9 67.1426C202.9 68.013 203.606 68.7187 204.476 68.7187Z"
            stroke="#C0CCD8"
            stroke-miterlimit="10"
          />
          <path
            d="M212.532 67.1426C212.532 67.4575 212.439 67.7653 212.264 68.0271C212.089 68.2889 211.84 68.4929 211.549 68.6134C211.258 68.7339 210.938 68.7654 210.629 68.704C210.321 68.6426 210.037 68.491 209.814 68.2683C209.592 68.0457 209.44 67.762 209.378 67.4532C209.317 67.1444 209.349 66.8243 209.469 66.5334C209.59 66.2425 209.794 65.9938 210.055 65.8189C210.317 65.644 210.625 65.5506 210.94 65.5506C211.362 65.5506 211.767 65.7183 212.066 66.0169C212.364 66.3154 212.532 66.7204 212.532 67.1426Z"
            stroke="#C0CCD8"
            stroke-miterlimit="10"
          />
          <path
            d="M219.011 67.1426C219.011 67.4575 218.918 67.7653 218.743 68.0271C218.568 68.2889 218.32 68.4929 218.029 68.6134C217.738 68.7339 217.418 68.7654 217.109 68.704C216.8 68.6426 216.516 68.491 216.294 68.2683C216.071 68.0457 215.919 67.762 215.858 67.4532C215.797 67.1444 215.828 66.8243 215.949 66.5334C216.069 66.2425 216.273 65.9938 216.535 65.8189C216.797 65.644 217.105 65.5506 217.419 65.5506C217.842 65.5506 218.247 65.7183 218.545 66.0169C218.844 66.3154 219.011 66.7204 219.011 67.1426Z"
            stroke="#C0CCD8"
            stroke-miterlimit="10"
          />
          <path
            d="M169.731 95.9737H146.44C144.189 95.9737 142.365 97.7984 142.365 100.049V123.34C142.365 125.591 144.189 127.416 146.44 127.416H169.731C171.982 127.416 173.807 125.591 173.807 123.34V100.049C173.807 97.7984 171.982 95.9737 169.731 95.9737Z"
            stroke="#C0CCD8"
            stroke-linejoin="round"
          />
          <path
            d="M158.086 120.697C163.058 120.697 167.088 116.667 167.088 111.695C167.088 106.723 163.058 102.692 158.086 102.692C153.113 102.692 149.083 106.723 149.083 111.695C149.083 116.667 153.113 120.697 158.086 120.697Z"
            stroke="#C0CCD8"
            stroke-width="3"
            stroke-miterlimit="10"
          />
          <path
            d="M164.167 105.343L151.455 118.055"
            stroke="#C0CCD8"
            stroke-width="3"
            stroke-miterlimit="10"
          />
          <path
            d="M500.135 187.53H476.844C474.593 187.53 472.768 189.354 472.768 191.605V214.896C472.768 217.147 474.593 218.972 476.844 218.972H500.135C502.386 218.972 504.21 217.147 504.21 214.896V191.605C504.21 189.354 502.386 187.53 500.135 187.53Z"
            stroke="#C0CCD8"
            stroke-linejoin="round"
          />
          <path
            d="M498.622 212.078C498.502 212.119 498.375 212.141 498.248 212.142H478.73C478.529 212.141 478.333 212.087 478.159 211.986C477.986 211.885 477.842 211.741 477.742 211.566C477.642 211.392 477.589 211.195 477.59 210.994C477.59 210.794 477.643 210.596 477.743 210.423L487.494 193.524C487.593 193.349 487.737 193.204 487.91 193.103C488.084 193.003 488.281 192.95 488.481 192.95C488.682 192.951 488.879 193.003 489.053 193.102C489.227 193.201 489.373 193.344 489.476 193.516L499.235 210.415C499.32 210.561 499.371 210.723 499.385 210.891C499.399 211.059 499.376 211.228 499.318 211.387C499.259 211.545 499.167 211.688 499.046 211.806C498.926 211.924 498.781 212.015 498.622 212.07V212.078ZM479.271 210.693H497.707L488.481 194.726L479.271 210.693Z"
            fill="#C0CCD8"
          />
          <path
            d="M488.489 207.334C488.31 207.336 488.138 207.268 488.008 207.145C487.879 207.021 487.803 206.852 487.797 206.673L487.399 200.027C487.392 199.88 487.415 199.734 487.467 199.597C487.518 199.459 487.597 199.334 487.698 199.228C487.799 199.121 487.921 199.036 488.055 198.978C488.19 198.92 488.335 198.889 488.481 198.889C488.628 198.888 488.773 198.918 488.908 198.975C489.043 199.032 489.165 199.116 489.267 199.222C489.369 199.327 489.448 199.452 489.501 199.589C489.553 199.726 489.577 199.872 489.572 200.019L489.174 206.673C489.168 206.851 489.093 207.019 488.965 207.142C488.837 207.265 488.667 207.334 488.489 207.334Z"
            fill="#C0CCD8"
          />
          <path
            d="M489.19 208.942C489.188 209.08 489.146 209.215 489.068 209.329C488.99 209.443 488.88 209.532 488.752 209.584C488.624 209.635 488.483 209.648 488.348 209.62C488.212 209.592 488.088 209.525 487.991 209.427C487.894 209.328 487.828 209.204 487.802 209.068C487.775 208.932 487.79 208.792 487.843 208.664C487.896 208.537 487.986 208.428 488.101 208.351C488.216 208.275 488.351 208.234 488.489 208.234C488.582 208.234 488.674 208.252 488.759 208.288C488.845 208.323 488.922 208.376 488.987 208.442C489.053 208.507 489.104 208.586 489.139 208.672C489.173 208.757 489.191 208.849 489.19 208.942Z"
            fill="#C0CCD8"
          />
          <path
            d="M76.7662 162.782C76.7662 163.133 76.6621 163.476 76.4671 163.768C76.272 164.06 75.9948 164.288 75.6704 164.422C75.3461 164.556 74.9892 164.591 74.6448 164.523C74.3005 164.454 73.9842 164.285 73.736 164.037C73.4877 163.789 73.3187 163.473 73.2502 163.128C73.1817 162.784 73.2168 162.427 73.3512 162.103C73.4855 161.778 73.7131 161.501 74.005 161.306C74.2969 161.111 74.6401 161.007 74.9911 161.007C75.4619 161.007 75.9134 161.194 76.2463 161.527C76.5792 161.86 76.7662 162.311 76.7662 162.782V162.782Z"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M374.773 257.355C374.774 257.706 374.672 258.05 374.478 258.343C374.283 258.636 374.007 258.865 373.683 259C373.358 259.136 373.001 259.172 372.656 259.105C372.311 259.037 371.994 258.869 371.745 258.621C371.496 258.373 371.326 258.056 371.257 257.712C371.188 257.367 371.223 257.01 371.357 256.685C371.491 256.36 371.719 256.083 372.011 255.887C372.303 255.692 372.646 255.588 372.998 255.588C373.467 255.588 373.917 255.774 374.25 256.105C374.583 256.436 374.771 256.885 374.773 257.355V257.355Z"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M496.656 111.695C496.658 112.046 496.555 112.39 496.361 112.683C496.167 112.976 495.89 113.205 495.566 113.34C495.242 113.476 494.885 113.512 494.54 113.445C494.195 113.377 493.878 113.209 493.629 112.961C493.38 112.713 493.21 112.396 493.141 112.052C493.072 111.707 493.106 111.35 493.241 111.025C493.375 110.7 493.602 110.423 493.894 110.227C494.186 110.032 494.53 109.928 494.881 109.928C495.351 109.928 495.801 110.114 496.134 110.445C496.466 110.776 496.654 111.225 496.656 111.695V111.695Z"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M400.913 56.8344C400.915 57.1858 400.812 57.5298 400.618 57.8228C400.424 58.1157 400.147 58.3445 399.823 58.48C399.499 58.6156 399.142 58.6519 398.797 58.5843C398.452 58.5167 398.135 58.3483 397.886 58.1004C397.637 57.8524 397.467 57.5362 397.398 57.1916C397.329 56.8471 397.364 56.4897 397.498 56.1649C397.632 55.8401 397.859 55.5624 398.151 55.367C398.443 55.1716 398.787 55.0673 399.138 55.0673C399.608 55.0673 400.058 55.2532 400.391 55.5844C400.723 55.9156 400.911 56.365 400.913 56.8344Z"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M493.114 169.707V175.2"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M495.86 172.453H490.36"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M349.524 275.527V281.02"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M352.27 278.274H346.777"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M233.355 46.7093V52.2017"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M236.102 49.4555H230.609"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M110.405 99.7945V105.295"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M113.151 102.549H107.659"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M101.458 226.263V231.755"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M104.204 229.009H98.7119"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M412.813 77.809V83.3014"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M415.56 80.5552H410.067"
            stroke="#C0CCD8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M142.325 195.02H87.361C86.9014 195.018 86.4613 194.834 86.1363 194.509C85.8113 194.184 85.6278 193.744 85.6257 193.285C85.6257 192.824 85.8083 192.382 86.1335 192.055C86.4587 191.728 86.9001 191.544 87.361 191.542H142.325C142.787 191.542 143.231 191.725 143.557 192.052C143.884 192.379 144.068 192.822 144.068 193.285C144.066 193.746 143.881 194.187 143.555 194.512C143.228 194.837 142.786 195.02 142.325 195.02V195.02Z"
            stroke="#C0CCD8"
            stroke-miterlimit="10"
          />
          <path
            d="M465.955 151.097H411.031C410.57 151.097 410.127 150.914 409.801 150.589C409.474 150.264 409.289 149.822 409.287 149.361C409.287 149.133 409.332 148.906 409.42 148.694C409.508 148.483 409.636 148.291 409.798 148.129C409.96 147.967 410.152 147.838 410.363 147.751C410.575 147.663 410.802 147.618 411.031 147.618H465.955C466.416 147.62 466.857 147.805 467.182 148.132C467.507 148.458 467.69 148.9 467.69 149.361V149.361C467.688 149.821 467.504 150.261 467.179 150.586C466.854 150.911 466.414 151.095 465.955 151.097V151.097Z"
            stroke="#C0CCD8"
            stroke-miterlimit="10"
          />
          <path
            d="M473.994 162.782H453.72C453.49 162.782 453.269 162.691 453.106 162.528C452.944 162.365 452.852 162.144 452.852 161.914C452.852 161.684 452.944 161.464 453.106 161.301C453.269 161.138 453.49 161.047 453.72 161.047H474.034C474.149 161.046 474.262 161.067 474.368 161.11C474.475 161.154 474.571 161.217 474.653 161.298C474.734 161.379 474.799 161.475 474.843 161.58C474.887 161.686 474.909 161.8 474.909 161.914C474.91 162.032 474.886 162.149 474.839 162.258C474.793 162.366 474.724 162.464 474.639 162.545C474.553 162.627 474.452 162.69 474.341 162.73C474.23 162.771 474.112 162.789 473.994 162.782Z"
            fill="#C0CCD8"
          />
          <path
            d="M420.232 121.366H399.91C399.796 121.366 399.682 121.343 399.577 121.299C399.471 121.255 399.375 121.191 399.294 121.109C399.213 121.028 399.15 120.931 399.107 120.825C399.063 120.719 399.042 120.605 399.043 120.491C399.043 120.26 399.134 120.04 399.297 119.877C399.46 119.714 399.68 119.623 399.91 119.623H420.232C420.462 119.623 420.683 119.714 420.846 119.877C421.009 120.04 421.1 120.26 421.1 120.491C421.101 120.605 421.079 120.719 421.036 120.825C420.993 120.931 420.929 121.028 420.849 121.109C420.768 121.191 420.672 121.255 420.566 121.299C420.46 121.343 420.347 121.366 420.232 121.366Z"
            fill="#C0CCD8"
          />
          <path
            d="M121.899 179.625H106.354C106.239 179.625 106.125 179.603 106.02 179.559C105.914 179.514 105.818 179.45 105.737 179.368C105.656 179.287 105.593 179.19 105.55 179.084C105.506 178.978 105.485 178.864 105.486 178.75C105.486 178.52 105.577 178.299 105.74 178.136C105.903 177.974 106.123 177.882 106.354 177.882H121.899C122.13 177.882 122.35 177.974 122.513 178.136C122.676 178.299 122.767 178.52 122.767 178.75C122.768 178.864 122.746 178.978 122.703 179.084C122.66 179.19 122.596 179.287 122.516 179.368C122.435 179.45 122.339 179.514 122.233 179.559C122.127 179.603 122.014 179.625 121.899 179.625Z"
            fill="#C0CCD8"
          />
          <path
            d="M435.611 102.907H452.438C454.065 102.907 455.384 101.588 455.384 99.9617V83.1342C455.384 81.5077 454.065 80.189 452.438 80.189H435.611C433.984 80.189 432.666 81.5077 432.666 83.1342V99.9617C432.666 101.588 433.984 102.907 435.611 102.907Z"
            stroke="#C0CCD8"
            stroke-linejoin="round"
          />
          <path
            d="M447.241 90.5928L446.851 92.543H449.016V94.2703H446.556L445.911 97.6851H444.065L444.717 94.2703H442.329L441.684 97.6851H439.878L440.498 94.2703H438.5V92.543H440.833L441.223 90.5928H439.105V88.8336H441.493L442.146 85.4108H443.985L443.34 88.8336H445.728L446.389 85.4108H448.196L447.535 88.8336H449.557V90.5928H447.241ZM442.616 92.543H445.004L445.402 90.5928H443.014L442.616 92.543Z"
            fill="#C0CCD8"
          />
          <path
            d="M252.73 260.069L236.77 155.403H164.891L182.125 266.31C182.663 269.916 184.494 273.203 187.276 275.56C190.059 277.916 193.603 279.181 197.249 279.117H318.153L319.037 268.96H263.221C260.69 269.009 258.228 268.132 256.297 266.495C254.366 264.859 253.098 262.574 252.73 260.069Z"
            fill="#475577"
          />
          <path
            d="M184.672 260.069L169.333 159.272C169.172 158.18 168.619 157.184 167.776 156.472C166.933 155.76 165.859 155.38 164.756 155.403H164.621C163.839 155.413 163.067 155.588 162.357 155.915C161.647 156.243 161.014 156.717 160.499 157.305C159.983 157.894 159.598 158.585 159.367 159.332C159.137 160.08 159.066 160.867 159.16 161.644L175.422 266.31C175.962 269.923 177.798 273.216 180.589 275.573C183.38 277.93 186.934 279.19 190.586 279.117H268.427L269.319 268.96H195.195C192.658 269.018 190.188 268.146 188.249 266.508C186.311 264.87 185.039 262.58 184.672 260.069Z"
            fill="#717A91"
          />
          <path
            d="M233.355 279.117V336.254"
            stroke="#544943"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M201.332 341.301C201.332 339.962 201.864 338.679 202.81 337.732C203.757 336.786 205.04 336.254 206.379 336.254H260.34C261.678 336.254 262.962 336.786 263.908 337.732C264.855 338.679 265.386 339.962 265.386 341.301"
            stroke="#544943"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M227.839 341.301C227.839 339.962 228.371 338.679 229.317 337.732C230.264 336.786 231.547 336.254 232.886 336.254"
            stroke="#544943"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M206.427 346.395C206.428 347.405 206.13 348.393 205.57 349.233C205.01 350.073 204.213 350.729 203.281 351.116C202.348 351.503 201.321 351.605 200.331 351.408C199.34 351.211 198.43 350.725 197.716 350.011C197.002 349.297 196.516 348.387 196.32 347.397C196.123 346.406 196.225 345.38 196.612 344.447C196.999 343.514 197.654 342.718 198.495 342.158C199.335 341.597 200.322 341.299 201.332 341.301C202.683 341.301 203.979 341.838 204.935 342.793C205.89 343.748 206.427 345.044 206.427 346.395Z"
            fill="#717A91"
          />
          <g opacity="0.45">
            <path
              d="M203.203 346.395C203.204 346.768 203.095 347.132 202.89 347.442C202.684 347.752 202.391 347.994 202.047 348.137C201.703 348.28 201.325 348.318 200.96 348.246C200.595 348.174 200.259 347.995 199.996 347.732C199.733 347.468 199.554 347.133 199.482 346.768C199.409 346.403 199.447 346.024 199.59 345.681C199.733 345.337 199.976 345.044 200.286 344.838C200.596 344.632 200.96 344.523 201.332 344.525C201.828 344.525 202.304 344.722 202.655 345.073C203.006 345.423 203.203 345.899 203.203 346.395Z"
              fill="#8E9DB2"
            />
          </g>
          <path
            d="M232.933 346.395C232.935 347.405 232.637 348.393 232.077 349.233C231.517 350.073 230.72 350.729 229.787 351.116C228.855 351.503 227.828 351.605 226.838 351.408C225.847 351.211 224.937 350.725 224.223 350.011C223.509 349.297 223.023 348.387 222.826 347.397C222.63 346.406 222.732 345.38 223.119 344.447C223.506 343.514 224.161 342.718 225.001 342.158C225.842 341.597 226.829 341.299 227.839 341.301C229.19 341.301 230.486 341.838 231.441 342.793C232.397 343.748 232.933 345.044 232.933 346.395Z"
            fill="#717A91"
          />
          <g opacity="0.45">
            <path
              d="M229.71 346.395C229.711 346.768 229.602 347.132 229.396 347.442C229.191 347.752 228.897 347.994 228.554 348.137C228.21 348.28 227.832 348.318 227.467 348.246C227.102 348.174 226.766 347.995 226.503 347.732C226.24 347.468 226.061 347.133 225.988 346.768C225.916 346.403 225.954 346.024 226.097 345.681C226.24 345.337 226.482 345.044 226.792 344.838C227.103 344.632 227.467 344.523 227.839 344.525C228.335 344.525 228.811 344.722 229.162 345.073C229.513 345.423 229.71 345.899 229.71 346.395Z"
              fill="#8E9DB2"
            />
          </g>
          <path
            d="M270.481 346.395C270.481 347.403 270.182 348.388 269.622 349.226C269.062 350.063 268.267 350.716 267.336 351.102C266.405 351.488 265.381 351.588 264.393 351.392C263.404 351.195 262.497 350.71 261.784 349.998C261.072 349.285 260.586 348.377 260.39 347.389C260.193 346.401 260.294 345.377 260.68 344.446C261.065 343.515 261.718 342.719 262.556 342.16C263.394 341.6 264.379 341.301 265.386 341.301C266.737 341.301 268.033 341.838 268.989 342.793C269.944 343.748 270.481 345.044 270.481 346.395Z"
            fill="#717A91"
          />
          <g opacity="0.45">
            <path
              d="M267.257 346.395C267.257 346.765 267.147 347.127 266.942 347.435C266.736 347.742 266.444 347.982 266.102 348.124C265.761 348.265 265.384 348.302 265.022 348.23C264.659 348.158 264.325 347.98 264.064 347.718C263.802 347.456 263.624 347.123 263.552 346.76C263.48 346.397 263.517 346.021 263.658 345.679C263.8 345.338 264.04 345.046 264.347 344.84C264.655 344.634 265.016 344.525 265.386 344.525C265.883 344.525 266.358 344.722 266.709 345.073C267.06 345.423 267.257 345.899 267.257 346.395Z"
              fill="#8E9DB2"
            />
          </g>
          <path
            d="M289.537 166.635L307.75 139.419L313.401 140.59C309.087 155.124 306.237 160.872 306.237 160.872"
            fill="#FFCBBB"
          />
          <path
            d="M310.496 145.103L313.401 140.59C313.401 140.59 318.806 139.348 320.764 138.345C322.519 137.433 323.878 135.909 324.585 134.062C325.007 132.916 324.824 129.533 324.33 129.477C323.168 129.35 320.852 133.68 319.769 133.943C318.687 134.206 315.16 133.943 313.226 134.182C312.234 134.354 311.296 134.759 310.491 135.364C309.686 135.968 309.035 136.755 308.593 137.66L305.616 143.065"
            fill="#FFCBBB"
          />
          <path
            d="M301.437 147.387L304.637 142.747L312.916 146.464L310.289 153.509"
            fill="#E6E8EF"
          />
          <path
            d="M234.971 137.708C234.971 137.708 248.463 131.499 260.348 142.07C272.232 152.641 280.248 162.464 284.626 165.64L302.528 145.047L312.525 149.744C309.891 164.653 302.488 188.437 284.387 190.889C264.797 193.532 236.07 169.397 236.07 169.397"
            fill="#B9B5B2"
          />
          <path
            d="M278.823 172.453L284.626 165.616"
            stroke="#846A6A"
            stroke-miterlimit="10"
          />
          <path
            d="M307.439 342.885L305.927 348.696C305.84 349.026 305.831 349.371 305.898 349.705C305.966 350.039 306.11 350.353 306.318 350.623C306.527 350.893 306.794 351.111 307.1 351.262C307.406 351.412 307.743 351.49 308.084 351.49H325.707C326.216 351.49 326.704 351.288 327.064 350.928C327.423 350.568 327.626 350.08 327.626 349.571C327.625 349.164 327.495 348.767 327.255 348.438C327.015 348.109 326.676 347.865 326.288 347.741L314.245 342.885"
            fill="#173789"
          />
          <path
            d="M297.282 252.03C294.464 281.601 307.439 342.885 307.439 342.885C307.439 342.885 310.52 346.61 314.245 342.885C314.245 342.885 317.373 284.451 320.661 258.183"
            fill="#FFCBBB"
          />
          <path
            d="M255.237 217.388L275.464 227.998V228.205C275.464 228.205 316.736 225.435 322.977 240.145C332.728 263.245 334.415 338.3 334.415 338.3H304.207C304.207 338.3 292.968 275.265 289.123 271.436C285.278 267.607 269.43 267.87 240.281 267.87C207.541 267.87 223.525 225.682 235.711 222.036"
            fill="#FCA32D"
          />
          <path
            d="M306.301 338.3C306.301 338.3 297.322 273.251 290.723 268.483C282.668 262.656 244.627 266.461 244.627 266.461"
            stroke="#CE680D"
            stroke-miterlimit="10"
          />
          <path
            d="M244.093 342.885L242.581 348.696C242.494 349.026 242.485 349.371 242.553 349.705C242.621 350.039 242.764 350.353 242.973 350.623C243.181 350.893 243.449 351.111 243.755 351.262C244.061 351.412 244.397 351.49 244.738 351.49H262.362C262.87 351.49 263.358 351.288 263.718 350.928C264.078 350.568 264.28 350.08 264.28 349.571C264.279 349.164 264.149 348.767 263.909 348.438C263.669 348.109 263.33 347.865 262.943 347.741L250.899 342.885"
            fill="#173789"
          />
          <path
            d="M247.023 252.03C244.213 281.601 244.093 342.885 244.093 342.885C244.093 342.885 247.174 346.61 250.899 342.885C250.899 342.885 261.502 284.451 264.797 258.183"
            fill="#FFCBBB"
          />
          <path
            d="M219.561 226.677C219.561 226.677 272.622 227.529 279.555 243.608C288.096 263.373 274.023 338.332 274.023 338.332H242.048V271.309C242.058 270.681 241.821 270.074 241.388 269.619C240.954 269.165 240.359 268.9 239.731 268.881C235.306 269 225.403 269 212.874 269C180.135 269 196.118 218.056 208.305 214.419"
            fill="#FFB548"
          />
          <path
            d="M219.561 226.677C219.561 226.677 272.622 227.529 279.555 243.608C281.871 248.965 283.073 258.087 282.453 268.96"
            stroke="#CE680D"
            stroke-miterlimit="10"
          />
          <path
            d="M246.505 338.3C246.505 338.3 246.832 271.022 245.287 267.456C243.138 262.465 235.807 264.917 218.796 264.917C186.057 264.917 199.398 218.048 211.585 214.419"
            stroke="#ED841B"
            stroke-miterlimit="10"
          />
          <path
            d="M199.183 234.868C199.183 234.868 215.987 235.274 218.534 232.727C221.081 230.179 218.534 218.637 218.534 218.637"
            stroke="#ED841B"
            stroke-miterlimit="10"
          />
          <path
            d="M198.769 237.12C198.769 237.12 217.961 237.534 220.866 234.979C223.771 232.424 220.866 220.866 220.866 220.866"
            stroke="#ED841B"
            stroke-miterlimit="10"
            stroke-dasharray="3 2"
          />
          <path
            d="M195.529 156.645C195.529 156.645 191.502 228.205 197.599 228.205C203.696 228.205 271.492 227.998 275.464 227.998C279.436 227.998 270.139 166.802 256.75 153.875C256.75 153.875 236.89 132.327 228.134 134.389C219.378 136.45 195.529 156.645 195.529 156.645Z"
            fill="#B9B5B2"
          />
          <path
            d="M271.157 189.193L262.744 154.687"
            stroke="#846A6A"
            stroke-miterlimit="10"
          />
          <path
            d="M161.238 169.604L143.017 142.388L137.374 143.559C141.688 158.086 144.538 163.841 144.538 163.841"
            fill="#FFCBBB"
          />
          <path
            d="M140.279 148.056L137.374 143.551C137.374 143.551 131.969 142.309 130.003 141.306C128.25 140.392 126.891 138.869 126.182 137.023C125.76 135.877 125.943 132.494 126.437 132.438C127.599 132.311 129.915 136.641 130.998 136.904C132.08 137.167 135.606 136.904 137.541 137.143C138.533 137.315 139.47 137.72 140.276 138.325C141.081 138.929 141.731 139.717 142.173 140.621L145.151 146.026"
            fill="#FFCBBB"
          />
          <path
            d="M149.33 150.356L146.13 145.716L137.851 149.433L140.486 156.478"
            fill="#E6E8EF"
          />
          <path
            d="M220.579 138.09C220.579 138.09 207.246 128.618 193.515 140.255C180.684 151.105 172.135 173.003 169.269 173.003C167.271 173.003 154.941 157.266 147.562 147.626L138.806 152.315C144.331 169.182 156.382 197.878 174.404 197.878C188.54 197.878 217.579 164.756 217.579 164.756"
            fill="#B9B5B2"
          />
          <path
            d="M194.367 187.283L215.851 169.365"
            stroke="#846A6A"
            stroke-miterlimit="10"
          />
          <path
            d="M221.861 139.786L234.677 153.509L236.348 137.644"
            fill="#E6E8EF"
          />
          <path
            d="M221.861 139.786L234.677 153.509L236.348 137.644"
            stroke="#846A6A"
            stroke-linejoin="round"
          />
          <path
            d="M232.153 125.927L235.759 133.824C235.759 133.824 237.208 138.353 231.198 140.398C229.394 141.077 227.432 141.219 225.549 140.81C223.665 140.4 221.94 139.456 220.58 138.09L219.632 125.704"
            fill="#FFCBBB"
          />
          <path
            d="M220.237 133.577C220.237 133.577 224.974 139.523 231.198 140.398L226.677 147.109C223.015 145.047 218.534 137.039 218.534 137.039L220.237 133.577Z"
            fill="white"
          />
          <path
            d="M235.377 132.741C234.724 135.633 233.277 138.285 231.198 140.398L236.348 144.291C237.534 141.378 237.399 136.84 237.399 136.84L235.377 132.741Z"
            fill="white"
          />
          <path
            d="M237.495 113.175C237.495 113.175 240.893 126.198 235.783 129.493C230.673 132.789 221.797 127.774 221.28 126.142C220.763 124.51 218.454 110.604 221.781 109.553C227.704 107.707 235.751 107.619 237.495 113.175Z"
            fill="#FFCBBB"
          />
          <path
            d="M237.383 117.402C237.415 117.531 237.407 117.666 237.361 117.791C237.316 117.916 237.234 118.024 237.126 118.102C237.019 118.18 236.891 118.224 236.758 118.229C236.625 118.234 236.494 118.199 236.381 118.129C236.268 118.059 236.179 117.957 236.124 117.836C236.07 117.715 236.052 117.581 236.074 117.45C236.096 117.319 236.157 117.197 236.248 117.101C236.34 117.005 236.458 116.938 236.587 116.909C236.672 116.888 236.76 116.885 236.845 116.899C236.931 116.913 237.014 116.944 237.088 116.99C237.162 117.036 237.226 117.096 237.276 117.166C237.327 117.237 237.363 117.317 237.383 117.402Z"
            fill="#173789"
          />
          <path
            d="M236.245 113.518C236.468 113.518 237.471 113.653 237.256 114.146C237.16 114.369 236.81 114.361 236.619 114.353C236.42 114.31 236.213 114.31 236.014 114.353C236.07 114.413 236.113 114.483 236.141 114.56C236.205 114.704 235.712 114.72 235.656 114.72C235.077 114.636 234.487 114.745 233.976 115.03C234.134 114.562 234.442 114.16 234.852 113.886C235.263 113.613 235.753 113.483 236.245 113.518Z"
            fill="#173789"
          />
          <path
            d="M229.192 119.201C229.199 119.333 229.244 119.461 229.324 119.567C229.403 119.673 229.512 119.754 229.636 119.798C229.761 119.842 229.896 119.849 230.025 119.816C230.153 119.783 230.269 119.713 230.358 119.615C230.446 119.516 230.503 119.393 230.522 119.262C230.541 119.131 230.52 118.997 230.462 118.878C230.405 118.759 230.313 118.659 230.199 118.592C230.085 118.525 229.953 118.493 229.821 118.501C229.645 118.511 229.48 118.59 229.362 118.721C229.245 118.853 229.184 119.025 229.192 119.201Z"
            fill="#173789"
          />
          <path
            d="M227.226 116.574C226.749 116.829 226.351 117.179 226.43 117.577C226.51 117.975 226.828 117.816 227.027 117.657C227.352 117.4 227.722 117.205 228.118 117.084C228.029 117.155 227.959 117.247 227.912 117.35C227.865 117.454 227.843 117.567 227.847 117.681C228.468 117.602 229.046 117.321 229.49 116.88C229.935 116.44 230.222 115.865 230.307 115.245C230.022 115.493 229.71 115.707 229.375 115.882C228.699 116.216 227.927 116.216 227.226 116.574Z"
            fill="#173789"
          />
          <path
            d="M234.072 118.174C234.072 118.174 235.887 122.751 235.242 123.149C234.597 123.547 232.312 123.483 232.312 123.483"
            stroke="#EF977F"
            stroke-miterlimit="10"
          />
          <path
            d="M234.143 130.25C232.517 130.804 230.78 130.949 229.084 130.671C227.389 130.393 225.788 129.702 224.424 128.658"
            stroke="#EF977F"
            stroke-miterlimit="10"
          />
          <path
            d="M231.198 127.193C231.198 127.193 231.66 125.179 234.971 125.179"
            stroke="#EF977F"
            stroke-miterlimit="10"
          />
          <path
            d="M240.392 106.186C240.4 105.56 240.198 104.95 239.819 104.451C239.546 104.221 239.231 104.048 238.89 103.941C238.55 103.834 238.192 103.797 237.837 103.83C235.319 103.812 232.86 104.595 230.816 106.067L232.48 104.618C232.926 104.236 233.905 103.631 233.435 102.915C232.965 102.198 231.843 102.644 231.222 102.636C228.372 102.636 225.65 103.623 222.999 104.626C221.69 105.082 220.429 105.666 219.234 106.369C218.034 107.08 217.07 108.13 216.464 109.386C216.017 110.52 215.816 111.735 215.875 112.952C215.946 115.135 216.18 117.309 216.576 119.456C216.95 121.844 217.515 126.437 220.675 126.723C221.28 126.847 221.91 126.751 222.45 126.453C222.675 126.251 222.856 126.006 222.983 125.732C223.11 125.459 223.181 125.162 223.19 124.861C223.305 123.878 223.243 122.884 223.007 121.923C223.596 122.242 224.154 122.783 224.822 122.68C224.932 122.67 225.038 122.632 225.128 122.569C225.219 122.506 225.292 122.421 225.34 122.321C225.372 122.185 225.372 122.044 225.34 121.907C225.093 119.655 224.966 117.418 224.814 115.157C228.046 114.473 231.296 113.884 234.565 113.39C236.014 113.175 237.55 112.936 238.673 111.997C240.273 110.644 240.551 108.256 240.392 106.186Z"
            fill="#173789"
          />
          <path
            d="M223.676 122.775C223.135 121.454 222.203 119.854 220.731 120.753C220.216 121.174 219.859 121.758 219.72 122.409C219.051 124.598 220.619 127.981 222.769 127.662C223.811 127.503 224.361 126.262 224.822 125.274"
            fill="#FFCBBB"
          />
          <path
            d="M418.816 264.98C418.803 259.647 420.433 254.439 423.483 250.064C426.534 245.689 430.857 242.36 435.866 240.527C437.72 239.851 446.572 239.182 446.572 239.182C446.572 239.182 445.545 245.94 443.778 249.347C439.663 257.307 431.528 263.962 418.816 264.98Z"
            fill="#8EBCA2"
          />
          <path
            d="M444.868 285.159C448.102 281.188 452.645 278.498 457.682 277.573C462.719 276.649 467.921 277.549 472.354 280.112C472.506 280.179 472.626 280.301 472.689 280.455C472.692 280.552 472.674 280.649 472.636 280.739C472.597 280.828 472.539 280.908 472.466 280.972C470.381 283.267 467.792 285.047 464.902 286.171C462.012 287.295 458.901 287.734 455.813 287.452C452.111 286.971 448.452 286.205 444.868 285.159Z"
            fill="#A2CCB6"
          />
          <path
            d="M451.985 274.373C451.985 268.196 454.046 262.648 457.676 259.01C459.551 257.192 461.816 255.827 464.3 255.018C466.783 254.21 469.418 253.98 472.004 254.346C472.201 254.353 472.388 254.432 472.529 254.569C472.678 254.776 472.738 255.034 472.697 255.285C472.386 262.728 468.653 268.889 462.961 271.356C459.418 272.734 455.742 273.744 451.993 274.373"
            fill="#8EBCA2"
          />
          <path
            d="M461.584 263.317C464.045 259.368 467.022 255.765 470.436 252.603C471.776 251.299 473.277 250.17 474.902 249.244C480.227 246.386 486.794 247.269 492.517 249.244C490.24 253.566 487.271 257.801 482.901 259.99C480.936 260.896 478.867 261.557 476.74 261.956C472.553 262.887 465.859 262.791 461.616 263.349"
            fill="#A2CCB6"
          />
          <path
            d="M458.536 252.993C447.885 247.421 446.317 235.775 446.046 231.501C445.879 228.81 446.046 225.809 448.299 223.867C461.497 228.516 464.872 237.447 458.536 253.025"
            fill="#8EBCA2"
          />
          <path
            d="M412.638 251.313C413.434 245.646 414.23 239.556 411.651 234.446C410.684 232.628 409.444 230.969 407.974 229.527C404.511 225.961 400.014 223.015 395.007 223.007C394.102 228.377 395.159 233.892 397.986 238.546C400.812 243.2 405.22 246.68 410.402 248.352"
            fill="#8EBCA2"
          />
          <path
            d="M443.619 288.391C440.635 287.396 437.887 285.799 435.544 283.7C433.201 281.601 431.313 279.045 429.997 276.187C428.682 273.33 427.965 270.234 427.893 267.089C427.821 263.945 428.394 260.818 429.577 257.904C429.592 257.766 429.645 257.635 429.731 257.526C429.817 257.417 429.932 257.335 430.063 257.289C430.194 257.243 430.336 257.236 430.471 257.267C430.606 257.298 430.729 257.367 430.827 257.466C440.013 262.744 446.301 278.114 443.619 288.367"
            fill="#A2CCB6"
          />
          <path
            d="M418.648 257.108C416.912 252.1 416.999 246.641 418.891 241.691C420.784 236.74 424.362 232.616 428.996 230.044C430.867 229.009 432.905 228.229 434.568 226.86C435.128 229.353 435.505 231.883 435.698 234.43C435.965 236.947 435.801 239.491 435.213 241.952C433.486 248.249 427.683 252.531 421.856 255.484"
            fill="#A2CCB6"
          />
          <path
            d="M410.951 256.129C401.399 257.283 389.61 253.423 384.492 244.412C400.85 236.102 410.951 248.822 410.951 256.129Z"
            fill="#A2CCB6"
          />
          <path
            d="M416.531 277.47C414.39 270.123 408.746 264.097 401.94 261.9C398.505 260.837 394.853 260.679 391.339 261.442C387.824 262.205 384.566 263.862 381.881 266.254C381.748 266.342 381.638 266.46 381.56 266.598C381.481 266.736 381.435 266.891 381.427 267.05C381.456 267.234 381.533 267.407 381.65 267.552C385.312 272.845 391.146 275.965 397.108 277.279C403.07 278.592 409.232 278.282 415.305 277.828"
            fill="#A2CCB6"
          />
          <path
            d="M404.233 238.299C409.192 243.258 412.288 249.546 414.581 256.097C416.922 262.901 418.768 269.866 420.105 276.936C423.042 291.798 423.822 306.834 425.534 321.855C425.534 322.062 425.884 322.078 425.876 321.855C425.29 306.469 423.501 291.152 420.527 276.045C419.119 268.682 417.103 261.448 414.501 254.418C412.216 248.352 409.144 242.629 404.368 238.139C404.256 238.036 404.097 238.195 404.201 238.299H404.233Z"
            fill="#597F6E"
          />
          <path
            d="M421.824 283.631C418.155 277.685 412.065 274.174 405.737 271.603C398.669 268.73 390.613 266.923 382.987 267.44C382.954 267.448 382.925 267.467 382.903 267.493C382.882 267.52 382.871 267.553 382.871 267.587C382.871 267.621 382.882 267.655 382.903 267.681C382.925 267.708 382.954 267.727 382.987 267.735C396.941 268.355 412.901 271.715 421.49 283.83C421.633 284.037 421.96 283.83 421.824 283.631Z"
            fill="#597F6E"
          />
          <path
            d="M418.927 269.669C418.871 264.097 418.282 258.445 419.388 252.897C420.383 247.802 422.49 242.988 425.557 238.8C425.645 238.673 425.446 238.521 425.342 238.633C417.86 247.055 417.773 259.09 418.752 269.677C418.752 269.788 418.935 269.796 418.927 269.677V269.669Z"
            fill="#597F6E"
          />
          <path
            d="M396.734 247.492C400.826 248.002 404.44 250.748 407.536 253.287C410.632 255.826 413.371 258.732 416.443 261.247C416.563 261.343 416.738 261.184 416.618 261.064C413.518 257.949 410.224 255.033 406.756 252.332C403.85 250.079 400.523 247.779 396.758 247.437C396.702 247.437 396.702 247.508 396.758 247.516L396.734 247.492Z"
            fill="#597F6E"
          />
          <path
            d="M439.885 302.4C442.13 290.763 446.811 280.112 454.588 271.062C458.335 266.695 462.641 262.841 467.395 259.599C472.386 256.216 477.743 253.908 483.315 251.791C483.365 251.777 483.407 251.744 483.432 251.699C483.458 251.655 483.464 251.602 483.451 251.552C483.437 251.502 483.404 251.46 483.359 251.435C483.314 251.409 483.261 251.403 483.212 251.417C471.917 254.362 461.505 262.163 454.046 270.95C446.588 279.738 440.968 290.85 439.583 302.361C439.583 302.528 439.838 302.568 439.87 302.361L439.885 302.4Z"
            fill="#597F6E"
          />
          <path
            d="M452.828 232.846C458.4 244.627 460.494 257.992 454.826 270.115C454.799 270.163 454.792 270.221 454.807 270.274C454.822 270.328 454.857 270.374 454.906 270.401C454.955 270.429 455.012 270.436 455.066 270.421C455.12 270.406 455.165 270.37 455.193 270.322C461.99 259.002 458.695 243.759 453.115 232.679C453.012 232.488 452.733 232.679 452.828 232.846Z"
            fill="#597F6E"
          />
          <path
            d="M460.088 294.671V303.992C460.088 340.975 450.353 351.49 450.353 351.49H420.232C420.232 351.49 410.489 340.975 410.489 303.992V294.671H460.088Z"
            fill="#F2F5F9"
          />
          <path
            d="M136.395 351.49L161.962 228.914"
            stroke="#544943"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M187.522 351.49L161.962 228.914"
            stroke="#544943"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M394.593 351.49L420.161 228.914"
            stroke="#544943"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M445.728 351.49L420.161 228.914"
            stroke="#544943"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M442.584 221.583H137.222V228.914H442.584V221.583Z"
            fill="#E7EAF2"
          />
          <path
            d="M427.866 207.605H319.992C319.539 207.605 319.092 207.506 318.682 207.314C318.272 207.123 317.909 206.844 317.619 206.497C317.328 206.15 317.117 205.744 317 205.307C316.884 204.87 316.864 204.413 316.943 203.967L329.345 134.229C329.534 133.159 330.094 132.189 330.926 131.491C331.759 130.792 332.811 130.409 333.898 130.409H441.78C442.232 130.409 442.679 130.508 443.089 130.699C443.499 130.891 443.862 131.169 444.153 131.516C444.444 131.863 444.655 132.269 444.771 132.706C444.888 133.144 444.908 133.601 444.829 134.046L432.427 203.776C432.239 204.849 431.679 205.822 430.845 206.522C430.01 207.223 428.955 207.606 427.866 207.605Z"
            fill="#475577"
          />
          <path
            d="M430.381 207.605H322.467C322.015 207.605 321.568 207.506 321.158 207.314C320.748 207.123 320.385 206.844 320.094 206.497C319.804 206.15 319.593 205.744 319.476 205.307C319.359 204.87 319.34 204.413 319.419 203.967L331.82 134.23C332.009 133.159 332.569 132.189 333.402 131.491C334.235 130.792 335.287 130.409 336.374 130.409H444.287C444.741 130.406 445.19 130.504 445.602 130.694C446.014 130.884 446.379 131.163 446.671 131.51C446.964 131.857 447.176 132.264 447.294 132.703C447.411 133.141 447.431 133.6 447.352 134.046L434.934 203.776C434.747 204.848 434.188 205.819 433.355 206.52C432.522 207.22 431.469 207.604 430.381 207.605Z"
            fill="#C0CCD8"
          />
          <path
            opacity="0.45"
            d="M410.521 207.605H348.194C347.933 207.604 347.675 207.546 347.439 207.436C347.203 207.325 346.993 207.164 346.826 206.963C346.658 206.763 346.536 206.529 346.469 206.277C346.401 206.024 346.39 205.76 346.435 205.503L353.599 165.226C353.711 164.608 354.036 164.049 354.517 163.646C354.999 163.243 355.606 163.022 356.234 163.021H418.561C418.822 163.022 419.079 163.079 419.316 163.19C419.552 163.301 419.762 163.462 419.929 163.662C420.097 163.862 420.219 164.097 420.286 164.349C420.354 164.601 420.365 164.865 420.32 165.122L413.124 205.368C413.02 205.986 412.702 206.549 412.227 206.957C411.751 207.366 411.148 207.595 410.521 207.605Z"
            fill="#8E9DB2"
          />
          <path
            d="M412.017 207.605H349.691C349.429 207.605 349.171 207.549 348.934 207.438C348.696 207.328 348.487 207.167 348.319 206.966C348.151 206.766 348.029 206.531 347.962 206.278C347.895 206.025 347.885 205.761 347.931 205.503L355.095 165.226C355.204 164.608 355.527 164.048 356.007 163.645C356.488 163.242 357.095 163.021 357.722 163.021H420.049C420.311 163.02 420.569 163.077 420.806 163.187C421.043 163.298 421.253 163.459 421.421 163.659C421.589 163.86 421.711 164.095 421.778 164.348C421.844 164.601 421.855 164.865 421.808 165.122L414.644 205.4C414.536 206.018 414.213 206.577 413.732 206.981C413.252 207.384 412.645 207.605 412.017 207.605Z"
            fill="#C6D2E0"
          />
          <path
            d="M398.207 183.916H372.91V207.605H398.207V183.916Z"
            fill="#8E9DB2"
          />
          <path
            d="M396.75 183.916H372.91V190.722L379.413 217.738H404.726L396.75 183.916ZM390.629 210.526C387.795 210.526 384.802 207.223 383.935 203.147C383.067 199.072 384.675 195.76 387.509 195.76C390.343 195.76 393.343 199.064 394.203 203.147C395.063 207.231 393.463 210.526 390.629 210.526Z"
            fill="#475577"
          />
          <path
            d="M358.996 217.738H415.655V221.583H355.159C355.159 220.564 355.563 219.588 356.282 218.867C357.002 218.146 357.978 217.74 358.996 217.738Z"
            fill="#475577"
          />
          <path
            d="M415.623 217.738H370.323V221.583H415.623V217.738Z"
            fill="#C0CCD8"
          />
          <path
            d="M398.215 183.916H372.91L380.87 217.738H406.183L398.215 183.916ZM392.006 210.526C389.172 210.526 386.172 207.223 385.312 203.147C384.452 199.072 386.044 195.76 388.878 195.76C391.712 195.76 394.713 199.064 395.572 203.147C396.432 207.231 394.816 210.526 392.006 210.526Z"
            fill="#C0CCD8"
          />
          <g opacity="0.65">
            <path
              d="M339.112 137.278L337.615 145.708H339.112L340.608 137.278H339.112Z"
              fill="#8E9DB2"
            />
            <path
              d="M343.45 137.278L341.954 145.708H343.45L344.947 137.278H343.45Z"
              fill="#8E9DB2"
            />
            <path
              d="M347.788 137.278L346.292 145.708H347.788L349.285 137.278H347.788Z"
              fill="#8E9DB2"
            />
            <path
              d="M352.127 137.278L350.63 145.708H352.127L353.623 137.278H352.127Z"
              fill="#8E9DB2"
            />
            <path
              d="M356.465 137.278L354.968 145.708H356.465L357.961 137.278H356.465Z"
              fill="#8E9DB2"
            />
          </g>
          <g opacity="0.65">
            <path
              d="M396.05 137.278L394.553 145.708H396.05L397.546 137.278H396.05Z"
              fill="#8E9DB2"
            />
            <path
              d="M400.611 137.278L399.106 145.708H400.611L402.107 137.278H400.611Z"
              fill="#8E9DB2"
            />
            <path
              d="M405.164 137.278L403.667 145.708H405.164L406.668 137.278H405.164Z"
              fill="#8E9DB2"
            />
            <path
              d="M409.725 137.278L408.229 145.708H409.725L411.229 137.278H409.725Z"
              fill="#8E9DB2"
            />
            <path
              d="M414.286 137.278L412.79 145.708H414.286L415.783 137.278H414.286Z"
              fill="#8E9DB2"
            />
            <path
              d="M418.847 137.278L417.343 145.708H418.847L420.344 137.278H418.847Z"
              fill="#8E9DB2"
            />
            <path
              d="M423.4 137.278L421.904 145.708H423.4L424.905 137.278H423.4Z"
              fill="#8E9DB2"
            />
            <path
              d="M427.961 137.278L426.465 145.708H427.961L429.458 137.278H427.961Z"
              fill="#8E9DB2"
            />
            <path
              d="M432.523 137.278L431.018 145.708H432.523L434.019 137.278H432.523Z"
              fill="#8E9DB2"
            />
            <path
              d="M437.076 137.278L435.579 145.708H437.076L438.58 137.278H437.076Z"
              fill="#8E9DB2"
            />
          </g>
          <g opacity="0.55">
            <path
              d="M223.238 202.471C223.617 202.405 223.965 202.221 224.233 201.945C224.822 201.149 223.843 200.258 223.206 199.844C222.41 199.326 221.264 199.151 220.866 198.14C220.468 197.129 221.192 195.752 222.124 195.139C222.942 194.668 223.813 194.294 224.719 194.025C225.752 193.69 226.649 193.028 227.274 192.138C227.998 190.984 227.855 189.504 227.942 188.206C228.317 183.128 233.514 180.604 237.884 180.501C240.073 180.453 243.409 181.233 244.865 182.937C245.367 183.501 245.713 184.187 245.868 184.927C245.952 185.477 245.907 186.039 245.737 186.57C245.567 187.1 245.277 187.584 244.889 187.983C244.06 188.74 243.191 189.452 242.286 190.117C241.443 190.913 242.048 191.756 241.849 192.712C241.65 193.667 240.925 194.224 240.01 194.733C238.068 195.816 235.783 196.087 233.642 196.676C232.977 196.814 232.346 197.085 231.787 197.472C231.168 198.101 230.633 198.807 230.195 199.573C229.225 200.881 227.809 201.787 226.215 202.12"
              fill="url(#paint0_linear_8595_1715)"
            />
          </g>
          <path
            d="M235.409 215.262H231.262V213.28H235.409C235.726 213.286 236.041 213.228 236.335 213.11C236.63 212.992 236.897 212.817 237.123 212.595C237.349 212.373 237.529 212.108 237.651 211.815C237.774 211.523 237.837 211.209 237.837 210.892V207.477C237.837 207.16 237.774 206.847 237.651 206.554C237.529 206.262 237.349 205.997 237.123 205.775C236.897 205.552 236.63 205.377 236.335 205.26C236.041 205.142 235.726 205.084 235.409 205.089H231.262V203.107H235.409C236.576 203.109 237.694 203.574 238.519 204.399C239.344 205.224 239.809 206.342 239.811 207.509V210.924C239.792 212.08 239.32 213.182 238.497 213.993C237.674 214.805 236.565 215.26 235.409 215.262Z"
            fill="#E8EAEF"
          />
          <path
            d="M217.626 200.242H234.342V215.597C234.342 216.889 233.829 218.128 232.916 219.041C232.002 219.955 230.763 220.468 229.471 220.468H222.474C221.182 220.468 219.943 219.955 219.029 219.041C218.116 218.128 217.603 216.889 217.603 215.597V200.242H217.626Z"
            fill="#E8EAEF"
          />
          <path
            d="M214.92 217.642C214.92 217.642 215.087 221.583 221.208 221.583H230.84C236.961 221.583 237.12 217.642 237.12 217.642H214.92Z"
            fill="#C6D2E0"
          />
          <path
            d="M349.468 220.006H260.889V221.583H349.468V220.006Z"
            fill="#475577"
          />
          <path
            d="M270.266 218.741H263.922V220.006H270.266V218.741Z"
            fill="#475577"
          />
          <path
            d="M279.874 218.741H273.53V220.006H279.874V218.741Z"
            fill="#475577"
          />
          <path
            d="M289.481 218.741H283.137V220.006H289.481V218.741Z"
            fill="#475577"
          />
          <path
            d="M299.089 218.741H292.745V220.006H299.089V218.741Z"
            fill="#475577"
          />
          <path
            d="M308.697 218.741H302.353V220.006H308.697V218.741Z"
            fill="#475577"
          />
          <path
            d="M318.305 218.741H311.96V220.006H318.305V218.741Z"
            fill="#475577"
          />
          <path
            d="M327.912 218.741H321.568V220.006H327.912V218.741Z"
            fill="#475577"
          />
          <path
            d="M337.52 218.741H331.176V220.006H337.52V218.741Z"
            fill="#475577"
          />
          <path
            d="M347.136 218.741H340.792V220.006H347.136V218.741Z"
            fill="#475577"
          />
          <path
            d="M350.63 220.006H262.051V221.583H350.63V220.006Z"
            fill="#C0CCD8"
          />
          <path
            d="M271.42 218.741H265.076V220.006H271.42V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M281.028 218.741H274.684V220.006H281.028V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M290.643 218.741H284.299V220.006H290.643V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M300.251 218.741H293.907V220.006H300.251V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M309.859 218.741H303.515V220.006H309.859V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M319.467 218.741H313.123V220.006H319.467V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M329.074 218.741H322.73V220.006H329.074V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M338.682 218.741H332.338V220.006H338.682V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M348.29 218.741H341.946V220.006H348.29V218.741Z"
            fill="#C0CCD8"
          />
          <path
            d="M136.005 280.988C137.116 276.576 136.635 271.914 134.646 267.822C132.657 263.73 129.287 260.471 125.131 258.62C123.46 257.872 121.661 257.355 120.14 256.32C119.846 258.494 119.71 260.686 119.734 262.879C119.688 265.055 120.016 267.222 120.705 269.287C122.648 274.548 127.933 277.78 133.139 279.866"
            fill="#8EBCA2"
          />
          <path
            d="M136.641 295.109C136.808 284.928 136.936 273.307 128.928 265.729C128.904 265.704 128.871 265.691 128.836 265.691C128.802 265.691 128.769 265.704 128.745 265.729C128.721 265.753 128.707 265.786 128.707 265.82C128.707 265.855 128.721 265.887 128.745 265.912C132.415 270.05 134.819 275.156 135.67 280.622C136.339 285.398 136.068 290.285 136.466 295.109C136.466 295.132 136.475 295.155 136.492 295.171C136.508 295.187 136.53 295.197 136.554 295.197C136.577 295.197 136.599 295.187 136.616 295.171C136.632 295.155 136.641 295.132 136.641 295.109Z"
            fill="#597F6E"
          />
          <path
            d="M123.635 308.458C123.24 305.434 122.238 302.521 120.689 299.893C119.141 297.266 117.078 294.978 114.624 293.167C112.186 291.402 109.416 290.149 106.481 289.481C104.833 289.099 97.2156 289.481 97.2156 289.481C97.2156 289.481 98.8076 295.125 100.702 297.839C105.072 304.16 112.73 308.983 123.675 308.442"
            fill="#8EBCA2"
          />
          <path
            d="M117.012 288.996C116.812 285.34 116.14 281.726 115.014 278.242C114.594 276.848 114.003 275.511 113.255 274.262C110.748 270.282 106.035 268.403 101.506 267.583C101.45 271.436 101.888 275.488 104.013 278.656C104.988 280.023 106.13 281.264 107.412 282.349C109.864 284.578 114.369 287.038 117.012 289.028"
            fill="#A2CCB6"
          />
          <path
            d="M142.683 275.687C141.975 270.815 141.314 265.585 143.535 261.191C144.371 259.626 145.445 258.201 146.719 256.965C149.696 253.908 153.588 251.393 157.863 251.393C158.624 256.003 157.715 260.733 155.3 264.734C152.912 268.714 147.125 274.286 142.723 275.711"
            fill="#A2CCB6"
          />
          <path
            d="M134.858 303.977C137.131 304.448 139.476 304.449 141.749 303.979C144.022 303.509 146.174 302.579 148.074 301.245C149.973 299.912 151.58 298.203 152.794 296.225C154.008 294.247 154.804 292.042 155.133 289.744C155.174 289.651 155.187 289.547 155.172 289.446C155.157 289.345 155.114 289.251 155.047 289.173C154.981 289.096 154.894 289.039 154.796 289.009C154.698 288.979 154.594 288.977 154.496 289.004C146.671 288.956 136.984 296.43 134.858 303.977Z"
            fill="#A2CCB6"
          />
          <path
            d="M118.755 286.369C125.203 282.739 129.35 275.472 129.469 267.567C124.813 267.305 121.31 270.17 119.281 272.638C116.463 276.077 116.224 282.118 118.755 286.369Z"
            fill="#A2CCB6"
          />
          <path
            d="M123.444 299.121C122.579 296.966 122.255 294.632 122.499 292.323C122.743 290.014 123.548 287.799 124.844 285.872C126.139 283.946 127.887 282.365 129.933 281.268C131.98 280.171 134.264 279.591 136.586 279.579C136.785 279.579 137.007 279.579 137.111 279.754C137.171 279.852 137.202 279.966 137.198 280.081C137.374 284.061 135.606 287.905 133.131 290.986C130.655 294.066 127.416 296.47 124.192 298.771"
            fill="#A2CCB6"
          />
          <path
            d="M149.751 264.352C141.163 272.519 138.154 285.605 135.869 296.781C133.263 309.797 131.725 323.004 131.268 336.27C131.268 336.493 131.587 336.485 131.611 336.27C133.155 323.375 133.76 310.448 136.291 297.672C138.544 286.273 141.441 273.044 149.911 264.519C150.014 264.415 149.855 264.256 149.751 264.352Z"
            fill="#597F6E"
          />
          <path
            d="M123.436 305.943C123.393 302.198 123.861 298.464 124.829 294.846C124.833 294.813 124.827 294.779 124.81 294.75C124.793 294.721 124.767 294.699 124.736 294.686C124.705 294.673 124.671 294.671 124.639 294.68C124.607 294.689 124.578 294.708 124.558 294.735C122.966 297.855 122.472 302.56 123.054 305.998C123.054 306.213 123.444 306.165 123.436 305.943Z"
            fill="#597F6E"
          />
          <path
            d="M123.969 273.028C118.819 277.701 117.505 287.491 119.607 293.835C119.615 293.868 119.636 293.896 119.666 293.913C119.695 293.931 119.729 293.935 119.762 293.927C119.795 293.919 119.823 293.897 119.84 293.868C119.857 293.839 119.862 293.804 119.854 293.772C118.325 287.141 118.827 278.146 124.033 273.076C124.033 273.076 124.033 272.988 123.969 273.02V273.028Z"
            fill="#597F6E"
          />
          <path
            d="M125.847 328.382C126.013 319.242 124.775 310.131 122.178 301.366C119.734 292.872 115.81 283.655 109.346 277.422C109.163 277.247 108.925 277.509 109.076 277.693C112.02 281.173 114.602 284.944 116.781 288.948C118.923 293.153 120.635 297.564 121.891 302.114C124.327 310.766 125.02 319.498 125.553 328.422C125.561 328.455 125.58 328.485 125.606 328.506C125.633 328.527 125.666 328.538 125.7 328.538C125.734 328.538 125.767 328.527 125.794 328.506C125.821 328.485 125.84 328.455 125.847 328.422V328.382Z"
            fill="#597F6E"
          />
          <path
            d="M152.187 312.733V319.101C152.187 344.326 143.821 351.498 143.821 351.498H117.927C117.927 351.498 109.562 344.334 109.562 319.101V312.733H152.187Z"
            fill="#F2F5F9"
          />
          <path
            d="M95.345 351.49H501.655"
            stroke="#475577"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M407.006 153.671L397.597 143.939H252.781C251.169 143.939 249.574 143.622 248.085 143.007C246.596 142.392 245.244 141.49 244.104 140.353C242.965 139.216 242.061 137.867 241.444 136.381C240.828 134.896 240.51 133.304 240.51 131.696V56.5421C240.51 53.295 241.803 50.181 244.104 47.885C246.405 45.589 249.526 44.2991 252.781 44.2991H398.24C401.495 44.2991 404.616 45.589 406.917 47.885C409.218 50.181 410.51 53.295 410.51 56.5421V152.261C410.512 152.667 410.392 153.065 410.165 153.402C409.938 153.739 409.615 154 409.238 154.152C408.86 154.304 408.446 154.339 408.048 154.253C407.65 154.168 407.287 153.965 407.006 153.671Z"
            fill="white"
            stroke="#C0CCD8"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M312.545 60.203C313.751 58.9978 315.705 58.9978 316.91 60.203L389.738 133.031C390.943 134.236 390.943 136.19 389.738 137.395C388.533 138.6 386.579 138.6 385.374 137.395L358.326 110.348C349.764 105.517 342.899 110.418 340.129 112.996C338.882 114.158 336.929 114.088 335.768 112.841C334.607 111.594 334.676 109.641 335.923 108.48C338.098 106.455 343.25 102.465 350.102 102.124L340.277 92.2986C335.915 93.9322 331.787 96.5743 328.181 100.208C326.981 101.418 325.027 101.426 323.817 100.225C322.607 99.0249 322.6 97.071 323.8 95.8612C327.322 92.3122 331.305 89.5379 335.56 87.5818L327.061 79.0832C323.477 81.262 320.086 83.9979 316.985 87.325C315.823 88.5718 313.87 88.6405 312.624 87.4785C311.377 86.3165 311.308 84.3638 312.47 83.117C315.59 79.7696 318.988 76.9382 322.585 74.6069L312.545 64.5672C311.34 63.362 311.34 61.4081 312.545 60.203ZM339.352 67.5489C343.238 66.6706 347.192 66.2425 351.141 66.2425H351.142C365.092 66.2427 379.069 71.5888 389.813 83.117C390.975 84.3638 390.906 86.3165 389.66 87.4785C388.413 88.6405 386.46 88.5718 385.298 87.325C375.787 77.1198 363.478 72.4145 351.142 72.4144H351.141C347.638 72.4144 344.141 72.7941 340.713 73.569C339.05 73.9447 337.398 72.9016 337.022 71.2393C336.646 69.5769 337.69 67.9247 339.352 67.5489ZM354.122 87.2251C354.426 85.548 356.031 84.4343 357.708 84.7376C365.331 86.1163 372.557 89.891 378.482 95.861C379.682 97.0707 379.675 99.0246 378.465 100.225C377.256 101.426 375.302 101.418 374.101 100.209C369.037 95.1063 362.946 91.9569 356.61 90.8109C354.933 90.5076 353.819 88.9022 354.122 87.2251ZM342.81 126.11C342.81 121.593 346.471 117.932 350.987 117.932C355.504 117.932 359.165 121.593 359.165 126.11C359.165 130.626 355.504 134.287 350.987 134.287C346.471 134.287 342.81 130.626 342.81 126.11Z"
            fill="#919EAB"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_8595_1715"
            x1="233.331"
            y1="202.471"
            x2="233.331"
            y2="180.501"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" stop-opacity="0.1" />
            <stop offset="1" stop-color="white" stop-opacity="0.4" />
          </linearGradient>
          <clipPath id="clip0_8595_1715">
            <rect width="597" height="398" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
